<template>
  <b-row>
    <template v-for="newsItem in news">
      <b-col cols="12" sm="6" lg="4" class="d-flex" :key="newsItem.id">
        <b-card no-body class="mb-4 w-100">
          <b-card-body class="d-flex flex-column">
            <b-card-title
              @click="detail(newsItem.id)"
              class="mb-0 c-h4"
              style="cursor:pointer; display: -webkit-box; -webkit-line-clamp: 2; line-clamp: 2; -webkit-box-orient: vertical; overflow: hidden; text-overflow: ellipsis; max-height: 2.4em;"
            >
                {{newsItem.title | truncate(40)}}
            </b-card-title>
            <div>
              <small class="text-muted c-text">by <span style="color:black">{{newsItem.user.NAME}}</span> | {{newsItem.datefix}}</small>
            </div> 
            <div class="ml-0 c-text" style="height:4vh;margin-top:2px">
              <b-badge pill style="margin-right:2px" variant="primary">
                {{newsItem.category.name}}
              </b-badge>
              <b-badge pill style="margin-right:2px; margin-top:1px !important;" variant="primary">
                {{newsItem.product.PRODUCT}}
              </b-badge>
            </div>

            <b-card-text class="d-flex flex-column flex-grow-1 mt-2 c-text">
              <div class="flex-grow-1" style="min-height:10vh">{{newsItem.body.replace(/<\/?[^>]+>/ig, " ") | truncate(100) }}</div>
              <hr class="w-100"/>
              <div class="d-flex flex-row justify-content-between">
                <span>
                  <feather-icon style="margin-bottom:3px;margin-left:3px" icon="EyeIcon" size="12" /> {{newsItem.seen.length}}
                  <feather-icon style="margin-bottom:3px;margin-left:3px" icon="ThumbsUpIcon" size="12" /> {{newsItem.like.length}}
                  <feather-icon style="margin-bottom:3px;margin-left:3px" icon="MessageCircleIcon" size="12" /> {{newsItem.comment.length}}
                  <feather-icon style="margin-bottom:3px;margin-left:3px" icon="PaperclipIcon" size="12" /> {{newsItem.file.length}}
                </span>
                <b-link class="card-link float-right" @click="detail(newsItem.id)">
                  Read more
                </b-link>
              </div>
            </b-card-text>
          </b-card-body>
        </b-card>
      </b-col>
    </template>
  </b-row>
</template>

<script>
import { BBadge, BCardBody, BAspect, BRow, BCol, BCardText, BButton, BCard, BLink, BCardTitle } from 'bootstrap-vue'

export default {
  props: {
    news: {
      type: Array,
    },
  },

  components: {
    BBadge,
    BAspect,
    BCard,
    BLink,
    BBadge,
    BCardText,
    BCardTitle,
    BRow,
    BCol,
    BButton,
    BCardBody
  },

  filters: {
    truncate: function(value, length, start = 0) {
      if (!value) return ''
      value = value.toString()
      if (value.length > length) {
        if (start > 0) {
          return value.substring(start, length + start)  + '...'
        } else {
          return value.substring(start, length) + '...'
        }
      } else {
        return value
      }
    },
  },

  methods: {
    detail(id){
      this.$router.push({name : 'discussion-detail', params:{key:id}})
    }
  }
}
</script>

<style scoped>
.card-img, .card-img-top, .card-img-bottom {
  height: calc(32.70vh/1.7);
}

@media only screen and (max-width: 1480px)  {
  .c-text {
    font-size: 0.75rem !important;
  }
  .c-h4 {
    font-size: 0.98rem !important;
  }
}

@media only screen and (min-width: 2000px)  {
  .c-text {
    font-size: 1.4rem !important;
  }
  .c-h4 {
    font-size: 1.5rem !important;
  }
}
</style>

<style>

</style>

<style lang="scss">
@import '@core/scss/vue/pages/ui-feather.scss';
</style>